<h2>Product Detail</h2>
@if (product()) {
    <mat-tab-group
        dynamicHeight
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        animationDuration="0"
    >
        <mat-tab label="Product">
            <div class="ttable">
                <div class="tcell">
                    <table class="detail-table">
                        <tr>
                            <th colspan="2">Product</th>
                        </tr>
                        <tr>
                            <td>Enabled</td>
                            <td>
                                @if (product().enabled) {
                                    <mat-icon class="material-icons enabled"
                                        >check_circle</mat-icon
                                    >
                                }
                                @if (!product().enabled) {
                                    <mat-icon class="material-icons disabled"
                                        >block</mat-icon
                                    >
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>ProductId</td>
                            <td>{{ product().id }}</td>
                        </tr>
                        <tr>
                            <td>ProductReference</td>
                            <td>{{ product().productReference }}</td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <td>{{ product().title }}</td>
                        </tr>
                        <tr>
                            <td>Description</td>
                            <td>{{ product().description }}</td>
                        </tr>
                        <tr>
                            <td>Priority</td>
                            <td>{{ product().priority }}</td>
                        </tr>
                        <tr>
                            <td>Product Content Type</td>
                            <td>{{ product().productContentType }}</td>
                        </tr>
                        <tr>
                            <td>Subscription Availability</td>
                            <td>
                                @if (product().subscriptionAvailability) {
                                    <mat-icon class="material-icons enabled"
                                        >check_circle</mat-icon
                                    >
                                }
                                @if (!product().subscriptionAvailability) {
                                    <mat-icon class="material-icons disabled"
                                        >block</mat-icon
                                    >
                                }
                            </td>
                        </tr>
                        <tr>
                            <td>Validity</td>
                            <td>
                                {{ product().validity?.quantity }}
                                {{ product().validity?.unit }}
                            </td>
                        </tr>
                        <tr>
                            <td>Note</td>
                            <td>{{ product().note }}</td>
                        </tr>
                    </table>
                </div>
                <div class="tcell">
                    <table class="detail-table">
                        <tr>
                            <th colspan="2">Provider</th>
                        </tr>
                        <tr>
                            <td>Provider</td>
                            <td>{{ product().provider?.name }}</td>
                        </tr>
                        <tr>
                            <td>Provider Id</td>
                            <td>{{ product().providerId }}</td>
                        </tr>
                        <tr>
                            <td>Provider Product Id</td>
                            <td>{{ product().productReference }}</td>
                        </tr>
                        <tr>
                            <td>Country</td>
                            <td>{{ product().countryId }}</td>
                        </tr>
                        <tr>
                            <td>Operator</td>
                            <td>{{ product().operator?.name }}</td>
                        </tr>
                        <tr>
                            <td>Service Category</td>
                            <td>{{ product().serviceCategory }}</td>
                        </tr>
                        <tr>
                            <td>Product Category</td>
                            <td>{{ product().productCategory }}</td>
                        </tr>
                        <tr>
                            <td>Product Sub Category</td>
                            <td>{{ product().productSubCategory }}</td>
                        </tr>
                        <tr>
                            <td>Routed</td>
                            <td>
                                @if (product().routed) {
                                    <mat-icon class="material-icons enabled"
                                        >check_circle</mat-icon
                                    >
                                }
                                @if (!product().routed) {
                                    <mat-icon class="material-icons disabled"
                                        >block</mat-icon
                                    >
                                }
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="tcell">
                    <table class="detail-table">
                        <tr>
                            <th colspan="2">Price</th>
                        </tr>
                        <tr>
                            <td>Price Amount</td>
                            <td>{{ product().price.amount }}</td>
                        </tr>
                        <tr>
                            <td>Price Currency</td>
                            <td>{{ product().currency }}</td>
                        </tr>
                        <tr>
                            <td>Override Price</td>
                            <td>{{ product().priceOverride?.formatted }}</td>
                        </tr>
                        <tr>
                            <td>Cost Amount</td>
                            <td>{{ product().cost.amount }}</td>
                        </tr>
                        <tr>
                            <td>Cost Currency</td>
                            <td>{{ product().cost.currency }}</td>
                        </tr>
                        <tr>
                            <td>Value Amount</td>
                            <td>{{ product().value.amount }}</td>
                        </tr>
                        <tr>
                            <td>Value Currency</td>
                            <td>{{ product().value.currency }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <table class="detail-table localization">
                <tr>
                    <th colspan="2">Localization</th>
                </tr>
                <tr>
                    <td>Title Content Key</td>
                    <td>
                        {{ product().titleContentKey }}
                        @if (product().titleContentKey) {
                            <div>
                                &#123;
                                <ul>
                                    @for (
                                        c of product().titleContentKeyValue;
                                        track c
                                    ) {
                                        <li>{{ c }}</li>
                                    }
                                </ul>
                                &#125;
                            </div>
                        }
                    </td>
                </tr>

                <tr>
                    <td>Description Content Key</td>
                    <td>
                        {{ product().descriptionContentKey }}
                        @if (product().descriptionContentKey) {
                            <div>
                                &#123;
                                <ul>
                                    @for (
                                        c of product()
                                            .descriptionContentKeyValue;
                                        track c
                                    ) {
                                        <li>{{ c }}</li>
                                    }
                                </ul>
                                &#125;
                            </div>
                        }
                    </td>
                </tr>

                <tr>
                    <td>Summary Key</td>
                    <td>
                        {{ product().summaryKey }}
                        @if (product().summaryKey) {
                            <div>
                                &#123;
                                <ul>
                                    @for (
                                        c of product().summaryKeyValue;
                                        track c
                                    ) {
                                        <li>{{ c }}</li>
                                    }
                                </ul>
                                &#125;
                            </div>
                        }
                    </td>
                </tr>
            </table>
        </mat-tab>
        <mat-tab label="Deliverables">
            <ng-template matTabContent>
                <app-productdeliverables
                    [productId]="product().id"
                ></app-productdeliverables>
            </ng-template>
        </mat-tab>
        <mat-tab label="ProductHistory">
            <ng-template matTabContent>
                <app-product-history
                    [productId]="product().id"
                ></app-product-history>
            </ng-template>
        </mat-tab>
        <mat-tab label="AI Deliverables">
            <ng-template matTabContent>
                <app-product-ai-deliverables
                    [productId]="product().id"
                ></app-product-ai-deliverables>
            </ng-template>
        </mat-tab>
        <mat-tab label="AI Locales">
            <ng-template matTabContent>
                <app-productlocales
                    [productId]="product().id"
                ></app-productlocales>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
} @else {
    <mat-spinner></mat-spinner>
}
